import { RUNTIME_BACKEND_URL } from '../../lib/backendUrl';
import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { isHesapSubdomain } from '../../lib/subdomain';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from 'sonner';
import { Loader2, UserPlus } from 'lucide-react';
import { BrandLogo } from '../../components/hesap/BrandLogo';
import { useHesapBranding } from '../../store/hesapBrandingStore';

const API = `${RUNTIME_BACKEND_URL}/api/hesap`;

export default function HesapRegisterPage() {
  const brandTitle = useHesapBranding(st => st.title);
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: '', email: '', phone: '', password: '', password2: '' });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const loginPath = isHesapSubdomain() ? '/giris' : '/hesap/giris';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.full_name.trim() || !form.email.trim()) { toast.error('Ad ve email zorunlu'); return; }
    if (form.password.length < 6) { toast.error('Şifre en az 6 karakter olmali'); return; }
    if (form.password !== form.password2) { toast.error('Şifreler eslesmiyor'); return; }

    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/register`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ full_name: form.full_name, email: form.email, phone: form.phone, password: form.password })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail || 'Kayit başarısız');
      setSuccess(data.message || true);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
        <div className="w-full max-w-sm text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-amber-500 mb-4">
            <UserPlus className="h-8 w-8 text-white" />
          </div>
          <h1 className="text-xl font-bold text-white mb-2">Kayıt Başarılı</h1>
          <p className="text-slate-400 text-sm mb-6" data-testid="hesap-register-success-msg">
            {typeof success === 'string' ? success : 'Hesabınız oluşturuldu. Admin onayından sonra giriş yapabilirsiniz.'}
          </p>
          <Button onClick={() => navigate(loginPath)} className="w-full bg-emerald-600 hover:bg-emerald-700">
            Giriş Sayfasına Dön
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-6">
          <div className="inline-flex mb-4"><BrandLogo boxClass="w-16 h-16 rounded-2xl" iconClass="h-8 w-8" testId="register-brand-logo" /></div>
          <h1 className="text-2xl font-bold text-white">{brandTitle}</h1>
          <p className="text-slate-400 text-sm mt-1">Yeni Hesap Olustur</p>
        </div>

        <form onSubmit={handleSubmit} className="bg-slate-800 rounded-xl p-6 space-y-3" data-testid="hesap-register-form">
          <div className="space-y-1.5">
            <Label className="text-slate-300">Ad Soyad *</Label>
            <Input value={form.full_name} onChange={(e) => setForm({...form, full_name: e.target.value})}
              placeholder="Adiniz Soyadiniz" className="bg-slate-700 border-slate-600 text-white" data-testid="register-name-input" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-slate-300">Email *</Label>
            <Input type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})}
              placeholder="email@adres.com" className="bg-slate-700 border-slate-600 text-white" data-testid="register-email-input" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-slate-300">Telefon</Label>
            <Input value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})}
              placeholder="05xx xxx xxxx" className="bg-slate-700 border-slate-600 text-white" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-slate-300">Şifre *</Label>
            <Input type="password" value={form.password} onChange={(e) => setForm({...form, password: e.target.value})}
              placeholder="En az 6 karakter" className="bg-slate-700 border-slate-600 text-white" data-testid="register-password-input" />
          </div>
          <div className="space-y-1.5">
            <Label className="text-slate-300">Şifre Tekrar *</Label>
            <Input type="password" value={form.password2} onChange={(e) => setForm({...form, password2: e.target.value})}
              placeholder="Şifrenizi tekrar girin" className="bg-slate-700 border-slate-600 text-white" data-testid="register-password2-input" />
          </div>
          <Button type="submit" className="w-full bg-emerald-600 hover:bg-emerald-700 mt-2" disabled={loading}>
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Kayıt Ol'}
          </Button>
        </form>

        <p className="text-center text-slate-400 text-sm mt-4">
          Zaten hesabiniz var mi?{' '}
          <Link to={loginPath} className="text-emerald-400 hover:underline">Giriş Yap</Link>
        </p>
      </div>
    </div>
  );
}
